<template>
  <div class="icon-picker-wrapper">
    <div class="input-wrapper">
      <input class="form-control" v-model="model[propName]" readonly style="padding-left: 32px;">
      <div class="icon-display" :style="iconDisplayStyle">
        <ion-icon :name="selectedIcon" style=" float:left;margin-top:-40px; margin-left: 5px"></ion-icon>
      </div>
      <button
          class="picker-button"
          type="button"
          @click="showModal = true"
      >
        <i class="fa fa-cube"></i>
      </button>
    </div>

    <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
      <div class="modal-body">
        <div style="width:500px; height: 130px; border-radius: 5px 5px 0 0; background: lightgrey">
          <svg @click.self="showModal = false" style="--fg: #888; margin-left: 450px; margin-top: 4px; margin-bottom: 4px;"
               width="26"
               height="26"
               viewBox="0 0 26 26" id="{!! $baseName !!}_close" data-toggle="modal"
               data-target="#{!! $baseName !!}_modal">
            <defs>
              <symbol id="icon-close" viewBox="0 0 26 26">
                <line x1="7" y1="7" x2="14" y2="14" stroke="var(--fg)" stroke-width="1.5"
                      stroke-linecap="round"/>
                <line x1="14" y1="7" x2="7" y2="14" stroke="var(--fg)" stroke-width="1.5"
                      stroke-linecap="round"/>
              </symbol>
            </defs>
            <use href="#icon-close" width="32" height="32"/>
          </svg>
          <input style="position:absolute; left: 40px; top: 36px; height: 32px; width: 350px; max-width: 350px"
                 v-model="searchQuery"
                 placeholder="Suchen..."
                 class="search-input form-control"
          />
          <div style="position:absolute; left: 350px; top: 40px; width: 32px; height: 24px; background: transparent;">
            <a class="fa fa-search" style="color: gray; transform: scale(1.5,1.5);"></a>
          </div>
          <p style="color: #575757; font-size: 11px; position:absolute; left: 40px; top: 74px;">
            <i>
              <a class="fa fa-exclamation-circle" style="color: #575757"></a> Bitte geben Sie Suchbegriffe in
              Englisch ein, um nach weiteren Icons zu suchen.
            </i></p>
          <select class="form-control" v-model="iconSet"
                  style="position:absolute; left: 40px; top: 104px; width: 200px; max-width: 200px">
            <option value="all">Alle</option>
            <option value="recommended">Empfohlen</option>
          </select>
        </div>
        <div class="icon-grid  modal-content">
          <button style="margin-top: 1px; margin-bottom: 1px;margin-right: 2px;"
                  v-for="icon in filteredIcons"
                  :key="icon"
                  class="icon-button"
                  @click="selectIcon(icon)">
            <ion-icon style="margin-top: 4px; font-size: 24px" :name="icon"></ion-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'IconPicker',
  props: ['model', 'propName'],
  config: {
    ignoredElements: ['ion-icon']
  },
  mounted() {
    //@ionic/vue is only supported on Vue3+ so we add some spaghetti here
    let scr = document.createElement('script')
    scr.setAttribute('src', 'https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.esm.js')
    scr.setAttribute('type', 'module')
    document.head.appendChild(scr)

    scr = document.createElement('script')
    scr.setAttribute('src', 'https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.js')
    scr.setAttribute('nomodule', '')
    document.head.appendChild(scr)
  },
  data() {
    return {
      iconSet: 'all',
      showModal: false,
      searchQuery: '',
      icons: [
        'logo-alipay',
        'logo-amazon',
        'logo-amplify',
        'logo-android',
        'logo-angular',
        'logo-apple',
        'logo-apple-appstore',
        'logo-apple-ar',
        'logo-behance',
        'logo-bitbucket',
        'logo-bitcoin',
        'logo-buffer',
        'logo-capacitor',
        'logo-chrome',
        'logo-closed-captioning',
        'logo-codepen',
        'logo-css3',
        'logo-designernews',
        'logo-deviantart',
        'logo-discord',
        'logo-docker',
        'logo-dribbble',
        'logo-dropbox',
        'logo-edge',
        'logo-electron',
        'logo-euro',
        'logo-facebook',
        'logo-firebase',
        'logo-firefox',
        'logo-flickr',
        'logo-foursquare',
        'logo-github',
        'logo-gitlab',
        'logo-google',
        'logo-google-playstore',
        'logo-hackernews',
        'logo-html5',
        'logo-instagram',
        'logo-ionic',
        'logo-ionitron',
        'logo-javascript',
        'logo-laravel',
        'logo-linkedin',
        'logo-markdown',
        'logo-mastodon',
        'logo-medium',
        'logo-microsoft',
        'logo-no-smoking',
        'logo-nodejs',
        'logo-npm',
        'logo-octocat',
        'logo-paypal',
        'logo-pinterest',
        'logo-playstation',
        'logo-pwa',
        'logo-python',
        'logo-react',
        'logo-reddit',
        'logo-rss',
        'logo-sass',
        'logo-skype',
        'logo-slack',
        'logo-snapchat',
        'logo-soundcloud',
        'logo-stackoverflow',
        'logo-steam',
        'logo-stencil',
        'logo-tableau',
        'logo-tiktok',
        'logo-tumblr',
        'logo-tux',
        'logo-twitch',
        'logo-twitter',
        'logo-usd',
        'logo-venmo',
        'logo-vercel',
        'logo-vimeo',
        'logo-vk',
        'logo-vue',
        'logo-web-component',
        'logo-wechat',
        'logo-whatsapp',
        'logo-windows',
        'logo-wordpress',
        'logo-xbox',
        'logo-xing',
        'logo-yahoo',
        'logo-yen',
        'logo-youtube',
        'add-circle-outline',
        'add-outline',
        'airplane-outline',
        'alarm-outline',
        'albums-outline',
        'alert-circle-outline',
        'alert-outline',
        'american-football-outline',
        'analytics-outline',
        'aperture-outline',
        'apps-outline',
        'archive-outline',
        'arrow-back-circle-outline',
        'arrow-back-outline',
        'arrow-down-circle-outline',
        'arrow-down-outline',
        'arrow-forward-circle-outline',
        'arrow-forward-outline',
        'arrow-redo-circle-outline',
        'arrow-redo-outline',
        'arrow-undo-circle-outline',
        'arrow-undo-outline',
        'arrow-up-circle-outline',
        'arrow-up-outline',
        'at-circle-outline',
        'at-outline',
        'attach-outline',
        'backspace-outline',
        'bag-add-outline',
        'bag-check-outline',
        'bag-handle-outline',
        'bag-outline',
        'bag-remove-outline',
        'balloon-outline',
        'ban-outline',
        'bandage-outline',
        'bar-chart-outline',
        'barbell-outline',
        'barcode-outline',
        'baseball-outline',
        'basket-outline',
        'basketball-outline',
        'battery-charging-outline',
        'battery-dead-outline',
        'battery-full-outline',
        'battery-half-outline',
        'beaker-outline',
        'bed-outline',
        'beer-outline',
        'bicycle-outline',
        'bluetooth-outline',
        'boat-outline',
        'body-outline',
        'bonfire-outline',
        'book-outline',
        'bookmark-outline',
        'bookmarks-outline',
        'bowling-ball-outline',
        'briefcase-outline',
        'browsers-outline',
        'brush-outline',
        'bug-outline',
        'build-outline',
        'bulb-outline',
        'bus-outline',
        'business-outline',
        'cafe-outline',
        'calculator-outline',
        'calendar-clear-outline',
        'calendar-number-outline',
        'calendar-outline',
        'call-outline',
        'camera-outline',
        'camera-reverse-outline',
        'car-outline',
        'car-sport-outline',
        'card-outline',
        'caret-back-circle-outline',
        'caret-back-outline',
        'caret-down-circle-outline',
        'caret-down-outline',
        'caret-forward-circle-outline',
        'caret-forward-outline',
        'caret-up-circle-outline',
        'caret-up-outline',
        'cart-outline',
        'cash-outline',
        'cellular-outline',
        'chatbox-ellipses-outline',
        'chatbox-outline',
        'chatbubble-ellipses-outline',
        'chatbubble-outline',
        'chatbubbles-outline',
        'checkbox-outline',
        'checkmark-circle-outline',
        'checkmark-done-circle-outline',
        'checkmark-done-outline',
        'checkmark-outline',
        'chevron-back-circle-outline',
        'chevron-back-outline',
        'chevron-collapse-outline',
        'chevron-down-circle-outline',
        'chevron-down-outline',
        'chevron-expand-outline',
        'chevron-forward-circle-outline',
        'chevron-forward-outline',
        'chevron-up-circle-outline',
        'chevron-up-outline',
        'clipboard-outline',
        'close-circle-outline',
        'close-outline',
        'cloud-circle-outline',
        'cloud-done-outline',
        'cloud-download-outline',
        'cloud-offline-outline',
        'cloud-outline',
        'cloud-upload-outline',
        'cloudy-night-outline',
        'cloudy-outline',
        'code-download-outline',
        'code-outline',
        'code-slash-outline',
        'code-working-outline',
        'cog-outline',
        'color-fill-outline',
        'color-filter-outline',
        'color-palette-outline',
        'color-wand-outline',
        'compass-outline',
        'construct-outline',
        'contract-outline',
        'contrast-outline',
        'copy-outline',
        'create-outline',
        'crop-outline',
        'cube-outline',
        'cut-outline',
        'desktop-outline',
        'diamond-outline',
        'dice-outline',
        'disc-outline',
        'document-attach-outline',
        'document-lock-outline',
        'document-outline',
        'document-text-outline',
        'documents-outline',
        'download-outline',
        'duplicate-outline',
        'ear-outline',
        'earth-outline',
        'easel-outline',
        'egg-outline',
        'ellipse-outline',
        'ellipsis-horizontal-circle-outline',
        'ellipsis-horizontal-outline',
        'ellipsis-vertical-circle-outline',
        'ellipsis-vertical-outline',
        'enter-outline',
        'exit-outline',
        'expand-outline',
        'extension-puzzle-outline',
        'eye-off-outline',
        'eye-outline',
        'eyedrop-outline',
        'fast-food-outline',
        'female-outline',
        'file-tray-full-outline',
        'file-tray-outline',
        'file-tray-stacked-outline',
        'film-outline',
        'filter-circle-outline',
        'filter-outline',
        'finger-print-outline',
        'fish-outline',
        'fitness-outline',
        'flag-outline',
        'flame-outline',
        'flash-off-outline',
        'flash-outline',
        'flashlight-outline',
        'flask-outline',
        'flower-outline',
        'folder-open-outline',
        'folder-outline',
        'football-outline',
        'footsteps-outline',
        'funnel-outline',
        'game-controller-outline',
        'gift-outline',
        'git-branch-outline',
        'git-commit-outline',
        'git-compare-outline',
        'git-merge-outline',
        'git-network-outline',
        'git-pull-request-outline',
        'glasses-outline',
        'globe-outline',
        'golf-outline',
        'grid-outline',
        'hammer-outline',
        'hand-left-outline',
        'hand-right-outline',
        'happy-outline',
        'hardware-chip-outline',
        'headset-outline',
        'heart-circle-outline',
        'heart-dislike-circle-outline',
        'heart-dislike-outline',
        'heart-half-outline',
        'heart-outline',
        'help-buoy-outline',
        'help-circle-outline',
        'help-outline',
        'home-outline',
        'hourglass-outline',
        'ice-cream-outline',
        'id-card-outline',
        'image-outline',
        'images-outline',
        'infinite-outline',
        'information-circle-outline',
        'information-outline',
        'invert-mode-outline',
        'journal-outline',
        'key-outline',
        'keypad-outline',
        'language-outline',
        'laptop-outline',
        'layers-outline',
        'leaf-outline',
        'library-outline',
        'link-outline',
        'list-circle-outline',
        'list-outline',
        'locate-outline',
        'location-outline',
        'lock-closed-outline',
        'lock-open-outline',
        'log-in-outline',
        'log-out-outline',
        'magnet-outline',
        'mail-open-outline',
        'mail-outline',
        'mail-unread-outline',
        'male-female-outline',
        'male-outline',
        'man-outline',
        'map-outline',
        'medal-outline',
        'medical-outline',
        'medkit-outline',
        'megaphone-outline',
        'menu-outline',
        'mic-circle-outline',
        'mic-off-circle-outline',
        'mic-off-outline',
        'mic-outline',
        'moon-outline',
        'move-outline',
        'musical-note-outline',
        'musical-notes-outline',
        'navigate-circle-outline',
        'navigate-outline',
        'newspaper-outline',
        'notifications-circle-outline',
        'notifications-off-circle-outline',
        'notifications-off-outline',
        'notifications-outline',
        'nuclear-outline',
        'nutrition-outline',
        'open-outline',
        'options-outline',
        'paper-plane-outline',
        'partly-sunny-outline',
        'pause-circle-outline',
        'pause-outline',
        'paw-outline',
        'pencil-outline',
        'people-circle-outline',
        'people-outline',
        'person-add-outline',
        'person-circle-outline',
        'person-outline',
        'person-remove-outline',
        'phone-landscape-outline',
        'phone-portrait-outline',
        'pie-chart-outline',
        'pin-outline',
        'pint-outline',
        'pizza-outline',
        'planet-outline',
        'play-back-circle-outline',
        'play-back-outline',
        'play-circle-outline',
        'play-forward-circle-outline',
        'play-forward-outline',
        'play-outline',
        'play-skip-back-circle-outline',
        'play-skip-back-outline',
        'play-skip-forward-circle-outline',
        'play-skip-forward-outline',
        'podium-outline',
        'power-outline',
        'pricetag-outline',
        'pricetags-outline',
        'print-outline',
        'prism-outline',
        'pulse-outline',
        'push-outline',
        'qr-code-outline',
        'radio-button-off-outline',
        'radio-button-on-outline',
        'radio-outline',
        'rainy-outline',
        'reader-outline',
        'receipt-outline',
        'recording-outline',
        'refresh-circle-outline',
        'refresh-outline',
        'reload-circle-outline',
        'reload-outline',
        'remove-circle-outline',
        'remove-outline',
        'reorder-four-outline',
        'reorder-three-outline',
        'reorder-two-outline',
        'repeat-outline',
        'resize-outline',
        'restaurant-outline',
        'return-down-back-outline',
        'return-down-forward-outline',
        'return-up-back-outline',
        'return-up-forward-outline',
        'ribbon-outline',
        'rocket-outline',
        'rose-outline',
        'sad-outline',
        'save-outline',
        'scale-outline',
        'scan-circle-outline',
        'scan-outline',
        'school-outline',
        'search-circle-outline',
        'search-outline',
        'send-outline',
        'server-outline',
        'settings-outline',
        'shapes-outline',
        'share-outline',
        'share-social-outline',
        'shield-checkmark-outline',
        'shield-half-outline',
        'shield-outline',
        'shirt-outline',
        'shuffle-outline',
        'skull-outline',
        'snow-outline',
        'sparkles-outline',
        'speedometer-outline',
        'square-outline',
        'star-half-outline',
        'star-outline',
        'stats-chart-outline',
        'stop-circle-outline',
        'stop-outline',
        'stopwatch-outline',
        'storefront-outline',
        'subway-outline',
        'sunny-outline',
        'swap-horizontal-outline',
        'swap-vertical-outline',
        'sync-circle-outline',
        'sync-outline',
        'tablet-landscape-outline',
        'tablet-portrait-outline',
        'telescope-outline',
        'tennisball-outline',
        'terminal-outline',
        'text-outline',
        'thermometer-outline',
        'thumbs-down-outline',
        'thumbs-up-outline',
        'thunderstorm-outline',
        'ticket-outline',
        'time-outline',
        'timer-outline',
        'today-outline',
        'toggle-outline',
        'trail-sign-outline',
        'train-outline',
        'transgender-outline',
        'trash-bin-outline',
        'trash-outline',
        'trending-down-outline',
        'trending-up-outline',
        'triangle-outline',
        'trophy-outline',
        'tv-outline',
        'umbrella-outline',
        'unlink-outline',
        'videocam-off-outline',
        'videocam-outline',
        'volume-high-outline',
        'volume-low-outline',
        'volume-medium-outline',
        'volume-mute-outline',
        'volume-off-outline',
        'walk-outline',
        'wallet-outline',
        'warning-outline',
        'watch-outline',
        'water-outline',
        'wifi-outline',
        'wine-outline',
        'woman-outline'
      ],
      specialIcons: [
        'add-outline', 'alert-circle-outline', 'bag-outline', 'bag-handle-outline', 'barcode-outline',
        'briefcase-outline', 'bulb-outline', 'calendar-outline', 'camera-outline', 'cart-outline', 'chatbox-outline',
        'chatbox-ellipses-outline', 'chatbubble-outline', 'chatbubble-ellipses-outline', 'checkmark-outline',
        'cloud-outline', 'cloud-done-outline', 'cloud-download-outline', 'color-palette-outline', 'compass-outline',
        'diamond-outline', 'document-text-outline', 'earth-outline', 'easel-outline', 'ellipsis-horizontal-outline',
        'ellipsis-vertical-outline', 'extension-puzzle-outline', 'eye-outline', 'flame-outline', 'flash-outline',
        'folder-outline', 'gift-outline', 'globe-outline', 'heart-outline', 'home-outline', 'image-outline', 'images-outline',
        'key-outline', 'eypad-outline', 'layers-outline', 'leaf-outline', 'location-outline', 'lock-closed-outline',
        'lock-open-outline', 'mail-outline', 'map-outline', 'megaphone-outline', 'menu-outline', 'navigate-outline',
        'newspaper-outline', 'notifications-outline', 'paper-plane-outline', 'person-outline', 'person-circle-outline',
        'pricetag-outline', 'print-outline', 'reader-outline', 'receipt-outline', 'reorder-four-outline', 'ribbon-outline',
        'save-outline', 'search-outline', 'settings-outline', 'shirt-outline', 'sparkles-outline', 'star-outline',
        'storefront-outline', 'ticket-outline', 'trash-outline', 'trophy-outline', 'videocam-outline', 'logo-euro', 'logo-facebook',
        'logo-instagram', 'logo-linkedin', 'logo-twitter', 'logo-vimeo', 'logo-whatsapp', 'logo-youtube'
      ]
    };
  },

  computed: {
    selectedIcon: {
      get() {
        return this.model[this.propName];
      },
      set(value) {
        this.$set(this.model, this.propName, value);
      }
    },
    filteredIcons() {
      if (this.iconSet === 'all') {
        return this.icons.filter(icon =>
            icon.includes(this.searchQuery.toLowerCase()) || this.searchQuery.trim() === ''
        );
      } else {
        return this.specialIcons.filter(icon =>
            icon.includes(this.searchQuery.toLowerCase()) || this.searchQuery.trim() === ''
        );
      }
    },
    iconDisplayStyle() {
      return {
        display: 'inline-block',
        marginRight: '10px',
        fontSize: '24px'
      };
    }
  },

  methods: {
    selectIcon(icon) {
      this.showModal = false;
      this.selectedIcon = icon;
      this.searchQuery = '';
    }
  }
};
</script>

<style scoped>
/* Previous styles remain mostly the same, adjusted for simplified layout */
.icon-display {
  vertical-align: middle;
}

.icon-button {
  background: whitesmoke;
  color: black;
  border: 1px solid lightgrey;
  width: 56px;
  margin-bottom: 5px
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  border-radius: 0 0 5px 5px;
  min-height: 300px;
  width: 500px;
  max-width: 500px;
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.icon-grid {
  background: whitesmoke;
}

.picker-button {
  background: lightgrey;
  border: none;
  padding: 6px 12px;
  cursor: pointer;
  vertical-align: middle;
  float: right;
  margin-top: -34.2px;
}
</style>